
import { makeStyles } from 'tss-react/mui';
import EDTypography from '../../../BaseComponents/Typography/EDTypography';

interface IProps {
  title: string;
  value: number | string;
}

const useStyles = makeStyles()({
  container: {
    display: 'flex',
    minWidth: 160,
    marginRight: 16,
  },
  title: {
    marginRight: 8,
  },
});

/**
 * En komponent för att standardisera titel/värde text för bakgrundsjobb
 */
const BakgrundsjobbItem: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { classes } = useStyles();
  return (
    <div className={classes.container}>
      <EDTypography className={classes.title}>
        <strong>{props.title}</strong>
      </EDTypography>
      <EDTypography>{props.value}</EDTypography>
    </div>
  );
};

export default BakgrundsjobbItem;
